import { useEffect } from 'react';
import { FormikProps, useFormik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

import { useCreateServiceInterruptionWithoutAuthMutation } from 'store/apis';

interface UseSupervisorSuspendServiceFormManagerProps {
  orgSlug: string;
  buildingId: number;
  scheduleId: number;
  userId: number;
  next?: (data?: any) => void;
}

export const useSupervisorSuspendServiceFormManager = ({
  orgSlug,
  buildingId,
  scheduleId,
  userId,
  next = () => {},
}: UseSupervisorSuspendServiceFormManagerProps) => {
  const [createServiceInterruption, { isLoading, isError, isSuccess }] =
    useCreateServiceInterruptionWithoutAuthMutation();

  const initialValues = {
    buildingId,
    scheduleId,
    userId,
    status: 'active',
    comment: '',
    impactsBuilding: false,
  };

  const validationSchema = Yup.object({
    comment: Yup.string().nullable().required('Input the reason of the service interruption'),
  });

  const formManager = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: ({ buildingId: building_id, scheduleId: serviceId, status, comment, impactsBuilding }) => {
      const interruption = {
        building_id,
        impactsBuilding,
        serviceId,
        status: status || 'active',
        comment,
        userId,
      };

      const mutateProps = { orgSlug, ...interruption };

      createServiceInterruption(mutateProps as any);
    },
  });

  useEffect(() => {
    if (isError) {
      toast.error('Creating service interruption has been failed');
    }

    if (!isLoading && isSuccess && !isError) {
      next();
    }
  }, [isLoading, isSuccess, isError]);

  const loading_submit = isLoading;

  return [{ formManager, loading_submit }] as [
    { formManager: FormikProps<typeof initialValues>; loading_submit: boolean },
  ];
};
